import { render, staticRenderFns } from "./QuartersChart.vue?vue&type=template&id=c06ca88a&scoped=true"
import script from "./QuartersChart.vue?vue&type=script&lang=ts"
export * from "./QuartersChart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c06ca88a",
  null
  
)

export default component.exports